import { format } from "date-fns";
import { graphql, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";
import { css } from "styled-components";
import { HR, IconCertificate, IconCheck, IconClockFast, P, Small } from "@upsolve/ui";

import Confetti from "../Layout/Confetti";
import ImageInContext from "../Media/ImageInContext";
import MockPhone from "./MockPhone";

const PhoneDemo = () => {
  const { blobDischarged } = useStaticQuery(graphql`
    query PhoneDemoQuery {
      blobDischarged: file(base: { eq: "blob-debt-discharged.png" }) {
        childImageSharp {
          fluid(quality: 90, maxHeight: 240, traceSVG: { color: "#3C5DFF", threshold: 50 }) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `);
  const stepTimer = 1800;
  const [oneDone, setOneDone] = useState(false);
  const [twoDone, setTwoDone] = useState(false);
  const [threeStart, setThreeStart] = useState(false);
  const [threeDone, setThreeDone] = useState(false);
  const [fourStart, setFourStart] = useState(false);
  const [fourDone, setFourDone] = useState(false);
  const [isPreviewingForms, setIsPreviewingForms] = useState(false);
  const [isCelebrating, setIsCelebrating] = useState(false);
  useEffect(() => {
    setTimeout(() => setOneDone(new Date()), stepTimer * 1);
    setTimeout(() => setTwoDone(new Date()), stepTimer * 2);
    setTimeout(() => setThreeStart(new Date()), stepTimer * 3);
    setTimeout(() => setThreeDone(new Date()), stepTimer * 4.5);
    setTimeout(() => setIsPreviewingForms(true), stepTimer * 6.5);
    setTimeout(() => setThreeDone(new Date()), stepTimer * 8);
    setTimeout(() => setFourStart(new Date()), stepTimer * 9.5);
    setTimeout(() => {
      setFourDone(new Date());
      setIsCelebrating(true);
    }, stepTimer * 11.5);
  }, []);
  return (
    <MockPhone cssOverrides={cssOverrides}>
      <span>
        My Bankruptcy
        <br /> Filing Tool
      </span>
      <HR />
      <div className={oneDone ? "phone__checklist__step done" : "phone__checklist__step"}>
        <IconCheck /> 1. Questionnaire
      </div>
      <div className={twoDone ? "phone__checklist__step done" : "phone__checklist__step"}>
        <IconCheck /> 2. Credit Course
      </div>
      <div
        className={threeDone ? "phone__checklist__step done" : `phone__checklist__step ${threeStart ? "active" : ""}`}
      >
        {threeDone ? <IconCheck /> : <IconClockFast />} 3.{" "}
        {threeStart && !threeDone ? "Generating Forms..." : "Generate Forms"}
      </div>
      {threeDone && (
        <>
          <div className="phone__sms-message">
            <div>
              <div className="from">
                Upsolve <span>now</span>
              </div>
              Your forms are ready to download!
            </div>
          </div>
          <div className="phone__checklist__files">
            <Small>Your Forms:</Small>
            <div>
              <div className="icon">
                <IconCertificate />
              </div>
              Bankruptcy_Filing_Packet_{format(threeDone, "hh-mm")}.pdf
            </div>
          </div>
        </>
      )}
      <div className={fourDone ? "phone__checklist__step done" : `phone__checklist__step ${fourStart ? "active" : ""}`}>
        {fourDone ? <IconCheck /> : <IconClockFast />} 4.{" "}
        {fourStart && !fourDone ? "Filing Bankruptcy..." : "File Bankruptcy"}
      </div>
      {isPreviewingForms && (
        <div className="phone__preview-docs">
          <div className="phone__preview-docs__download">Download Filing Packet</div>
        </div>
      )}
      {isCelebrating && (
        <div className="phone__discharged">
          <ImageInContext
            alt="Drawing of a person filing for Chapter 7 bankruptcy online"
            fluid={blobDischarged.childImageSharp.fluid}
          />
          <P className="congrats">Discharged!</P>
          <P>
            <b>You successfully filed bankruptcy and your debts are erased!</b>
          </P>
          <P>We wish you the best with your fresh start.</P>
          <Small>- the Upsolve team</Small>
          <Confetti />
        </div>
      )}
    </MockPhone>
  );
};

const cssOverrides = css`
  position: relative;
  left: 140px;
  margin-top: 20px;
  top: 32px;
  transform: rotate(4deg);
  @media (max-width: ${(props) => props.theme.breakpoints[500]}) {
    left: 0;
    top: 0;
    margin-top: 0;
    transform: rotate(0);
  }
  .phone__preview-docs {
    animation: preview-docs 6s ease-in-out;
    @keyframes preview-docs {
      0% {
        top: 1000px;
      }
      10% {
        top: 0;
      }
      90% {
        top: 0;
      }
      100% {
        top: 1000px;
      }
    }
    background: url("/images/preview-docs-screenshot.png") ${(props) => props.theme.colors.gray[300]};
    background-size: 90%;
    background-repeat: no-repeat;
    background-position: bottom;
  }
`;

export default PhoneDemo;
